import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    language: '',  //zh tw en ja ko
    isLogin: false,
    userInfo: null,
    roleInfo: null,
  },
  getters: {
    language: state => state.language,
    isLogin: state => state.isLogin,
    userInfo: state => state.userInfo,
    roleInfo: state => state.roleInfo
  },
  mutations: {
    changeLanguage(state, val) {
      state.language = val
    },
    setLoginStatus(state, status) {
      state.isLogin = status
    },
    setUserInfo(state, info) {
      state.userInfo = info || null
    },
    clearUserInfo(state) {
      state.userInfo = null
    },
    setRoleInfo(state, info) {
      state.roleInfo = info || null
    },
    clearRoleInfo(state) {
      state.roleInfo = null
    },
  },
  actions: {},
  modules: {},
    plugins: [createPersistedState({
    storage: window.localStorage
  })]
});
